module.exports = __webpack_public_path__ + "home.82df19cb5cafca3272c0.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/Jose.Soto/Documents/Websites/SecretSanta/src/assets/home.jpg
// module id = ../../../../../src/assets/home.jpg
// module chunks = styles